import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { HomepageLayoutComponent } from './homepage-layout/homepage-layout.component';
import { HeaderMenuComponent } from './header-menu/header-menu.component';
import { AboutInstituteComponent } from './about-institute/about-institute.component';
import { AboutRgiComponent } from './about-rgi/about-rgi.component';
import { VisionMissionComponent } from './vision-mission/vision-mission.component';
import { ChairmansMessageComponent } from './chairmans-message/chairmans-message.component';
import { PrincipleMessageComponent } from './principle-message/principle-message.component';
import { CoreValueComponent } from './core-value/core-value.component';
import { CodeOfConductComponent } from './code-of-conduct/code-of-conduct.component';
import { GoverningBodyComponent } from './governing-body/governing-body.component';
import { AdmissionOverviewComponent } from './admission-overview/admission-overview.component';
import { StudentScholarshipComponent } from './student-scholarship/student-scholarship.component';
import { RgiScholarshipComponent } from './rgi-scholarship/rgi-scholarship.component';
import { AdmissionHelplineComponent } from './admission-helpline/admission-helpline.component';
import { FaqComponent } from './faq/faq.component';
import { OnlineFeesPaymentComponent } from './online-fees-payment/online-fees-payment.component';
import { UgBachelorOfBusinessAdministrationComputerApplicationComponent } from './ug-bachelor-of-business-administration-computer-application/ug-bachelor-of-business-administration-computer-application.component';
import { UgBachelorOfBusinessAdministrationComponent } from './ug-bachelor-of-business-administration/ug-bachelor-of-business-administration.component';
import { UgBachelorOfScienceComputerSciencenComponent } from './ug-bachelor-of-science-computer-sciencen/ug-bachelor-of-science-computer-sciencen.component';
import { UgBachelorOfCommerceComponent } from './ug-bachelor-of-commerce/ug-bachelor-of-commerce.component';
import { UgBachelorOfArtsComponent } from './ug-bachelor-of-arts/ug-bachelor-of-arts.component';
import { UgBachelorOfScienceComponent } from './ug-bachelor-of-science/ug-bachelor-of-science.component';
import { UgBachelorOfScienceHospitalityStudiesComponent } from './ug-bachelor-of-science-hospitality-studies/ug-bachelor-of-science-hospitality-studies.component';
import { PgMastersOfCommerceComponent } from './pg-masters-of-commerce/pg-masters-of-commerce.component';
import { PgMastersOfScienceComputerScienceComponent } from './pg-masters-of-science-computer-science/pg-masters-of-science-computer-science.component';
import { AcademicCalenderComponent } from './academic-calender/academic-calender.component';
import { CodeOfEthicsComponent } from './code-of-ethics/code-of-ethics.component';
import { FeedbackProcessComponent } from './feedback-process/feedback-process.component';
import { StudentProjectsComponent } from './student-projects/student-projects.component';
import { QuestionPaperComponent } from './question-paper/question-paper.component';
import { GrievanceRegistrationFormComponent } from './grievance-registration-form/grievance-registration-form.component';
import { MinorityCellCommitteeComponent } from './minority-cell-committee/minority-cell-committee.component';
import { AntiRaggingCommitteeComponent } from './anti-ragging-committee/anti-ragging-committee.component';
import { CollegeDevelopmentCommitteeComponent } from './college-development-committee/college-development-committee.component';
import { GrievanceRedressalCommitteeComponent } from './grievance-redressal-committee/grievance-redressal-committee.component';
import { ExamGrievanceRedressalCommitteeComponent } from './exam-grievance-redressal-committee/exam-grievance-redressal-committee.component';
import { NssCommitteeComponent } from './nss-committee/nss-committee.component';
import { NaacCommitteeComponent } from './naac-committee/naac-committee.component';
import { ObcCellCommitteeComponent } from './obc-cell-committee/obc-cell-committee.component';
import { ScStCommitteeComponent } from './sc-st-committee/sc-st-committee.component';
import { SportsCulturalCommitteeComponent } from './sports-cultural-committee/sports-cultural-committee.component';
import { StudentCouncilCommitteeComponent } from './student-council-committee/student-council-committee.component';
import { TrainingPlacementCommitteeComponent } from './training-placement-committee/training-placement-committee.component';
import { WomensGrievanceRedressalCommitteeComponent } from './womens-grievance-redressal-committee/womens-grievance-redressal-committee.component';
import { PlacementProcessComponent } from './placement-process/placement-process.component';
import { PlacementTeamComponent } from './placement-team/placement-team.component';
import { InternshipComponent } from './internship/internship.component';
import { PastRecruitersComponent } from './past-recruiters/past-recruiters.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { RocsComponent } from './rocs/rocs.component';
import { AboutIqacComponent } from './about-iqac/about-iqac.component';
import { ObjectivesComponent } from './objectives/objectives.component';
import { FunctionsComponent } from './functions/functions.component';
import { IqacMembersComponent } from './iqac-members/iqac-members.component';
import { MinutesOfMeetingComponent } from './minutes-of-meeting/minutes-of-meeting.component';
import { AtrComponent } from './atr/atr.component';
import { DocumentsComponent } from './documents/documents.component';
import { PoCoComponent } from './po-co/po-co.component';
import { CourseOutcomesComponent } from './course-outcomes/course-outcomes.component';
import { NaacComponent } from './naac/naac.component';
import { HostelComponent } from './hostel/hostel.component';
import { StudentLifeComponent } from './student-life/student-life.component';
import { AtheleticsSportsComponent } from './atheletics-sports/atheletics-sports.component';
import { LibraryComponent } from './library/library.component';
import { LabsComponent } from './labs/labs.component';
import { ContactComponent } from './contact/contact.component';
import { EventsComponent } from './events/events.component';
import { NotfoundComponent } from './notfound/notfound.component';
import { FeesStructureComponent } from './fees-structure/fees-structure.component';
import { CityOfficeComponent } from './city-office/city-office.component';
import { KimbaComponent } from './kimba/kimba.component';
import { OnlineAntiRaggingAffidavitsComponent } from './online-anti-ragging-affidavits/online-anti-ragging-affidavits.component';
import { AqarComponent } from './aqar/aqar.component';
import { IctToolsComponent } from './ict-tools/ict-tools.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { LoginComponent } from './login/login.component';
import { BbaEntranceComponent } from './bba-entrance/bba-entrance.component';
import { ExamGrievanceComponent } from './exam-grievance/exam-grievance.component';
import { AdmissionCellCommitteeComponent } from './admission-cell-committee/admission-cell-committee.component';
import { PlanningEvaluationCommitteeComponent } from './planning-evaluation-committee/planning-evaluation-committee.component';
import { AcademicMonitoringDisciplineCommitteeComponent } from './academic-monitoring-discipline-committee/academic-monitoring-discipline-committee.component';
import { ExaminationCommitteeComponent } from './examination-committee/examination-committee.component';
import { ResearchDevelopmentCommitteeComponent } from './research-development-committee/research-development-committee.component';
import { BuildingMaintenancePurchaseCommitteeComponent } from './building-maintenance-purchase-committee/building-maintenance-purchase-committee.component';
import { BlogComponent } from './blog/blog.component';
import { WhyAnBBAIsBestSuitedForYouComponent } from './why-an-bba-is-best-suited-for-you/why-an-bba-is-best-suited-for-you.component';
import { WhyBscComputerScienceIsTheBestOrientedCourseComponent } from './why-bsc-computer-science-is-the-best-oriented-course/why-bsc-computer-science-is-the-best-oriented-course.component';
import { Aqar21Component } from './aqar21/aqar21.component';
import { HowToGetAdmissionToBcomComponent } from './how-to-get-admission-to-bcom/how-to-get-admission-to-bcom.component';
import { WhyDidWeChooseBbaInComputerApplicationsComponent } from './why-did-we-choose-bba-in-computer-applications/why-did-we-choose-bba-in-computer-applications.component';
import { TwentyOneComponent } from './aqar-tweety/twenty-one/twenty-one.component';
import { BScInComputerScienceComponent } from './b-sc-in-computer-science/b-sc-in-computer-science.component';
import { BachelorOfCommerceDegreeComponent } from './bachelor-of-commerce-degree/bachelor-of-commerce-degree.component';
import { BachelorsDegreeInBusinessAdministrationComponent } from './bachelors-degree-in-business-administration/bachelors-degree-in-business-administration.component';
import { BachelorOfCommerceDegreeAComprehensiveGuideComponent } from './bachelor-of-commerce-degree-a-comprehensive-guide/bachelor-of-commerce-degree-a-comprehensive-guide.component';
import { BachelorOfBusinessAdministrationProgramComponent } from './bachelor-of-business-administration-program/bachelor-of-business-administration-program.component';
import { BachelorOfBusinessAdministrationDegreeComponent } from './bachelor-of-business-administration-degree/bachelor-of-business-administration-degree.component';
import { WhyChooseABachelorOfCommerceComponent } from './why-choose-a-bachelor-of-commerce/why-choose-a-bachelor-of-commerce.component';
import { BachelorsDegreeAfterTwelveCommerceComponent } from './bachelors-degree-after-twelve-commerce/bachelors-degree-after-twelve-commerce.component';
import { BbaComputerApplicationsComponent } from './bba-computer-applications/bba-computer-applications.component';
import { BachelorOfBusinessDegreeComponent } from './bachelor-of-business-degree/bachelor-of-business-degree.component';
import { BachelorDegreeComponent } from './bachelor-degree/bachelor-degree.component';
import { TipsForCommerceStudentsPursuingABComDegreeComponent } from './tips-for-commerce-students-pursuing-a-b-com-degree/tips-for-commerce-students-pursuing-a-b-com-degree.component';
import { WhyPursueBachelorOfComputerApplicationComponent } from './why-pursue-bachelor-of-computer-application/why-pursue-bachelor-of-computer-application.component';
import { ScopeOfBbaComponent } from './scope-of-bba/scope-of-bba.component';
import { BscComputerScienceCourseComponent } from './bsc-computer-science-course/bsc-computer-science-course.component';
import { TipsForBscComputerScienceStudentComponent } from './tips-for-bsc-computer-science-student/tips-for-bsc-computer-science-student.component';
import { AdvantagesOfBbaDegreeComponent } from './advantages-of-bba-degree/advantages-of-bba-degree.component';
import { BbaInComputerApplicationComponent } from './bba-in-computer-application/bba-in-computer-application.component';
import { BestBbaCoursesComponent } from './best-bba-courses/best-bba-courses.component';
import { TopUniversitiesForBbaProgramsComponent } from './top-universities-for-bba-programs/top-universities-for-bba-programs.component';
import { CareerOptionsAfterBachelorOfCommerceComponent } from './career-options-after-bachelor-of-commerce/career-options-after-bachelor-of-commerce.component';
import { BbaInComputerApllicationsComponent } from './bba-in-computer-apllications/bba-in-computer-apllications.component';
import { MComComponent } from './m-com/m-com.component';
import { PgMscComponent } from './pg-msc/pg-msc.component';
import { TwentytwoTwentythreeComponent } from './twentytwo-twentythree/twentytwo-twentythree.component';
import { BscItComponent } from './bsc-it/bsc-it.component';
import { BbaInternationalBusinessComponent } from './bba-international-business/bba-international-business.component';
import { MscComputerScienceComponent } from './msc-computer-science/msc-computer-science.component';
import { BscComputerAplicationComponent } from './bsc-computer-aplication/bsc-computer-aplication.component';
import { RecrutersCourseComponent } from './recruters-course/recruters-course.component';
import { DirectorMessageComponent } from './director-message/director-message.component';
import { ExamCircularsComponent } from './exam-circulars/exam-circulars.component';
import { LatestNewsComponent } from './latest-news/latest-news.component';
import { TwentythreeTwentyfourComponent } from './twentythree-twentyfour/twentythree-twentyfour.component';
import { DivyangCommitteeComponent } from './divyang-committee/divyang-committee.component';
import { StudentsAchievementComponent } from './students-achievement/students-achievement.component';
import { PopupModalComponent } from './popup-modal/popup-modal.component';
import { WomenEmpowermentComponent } from './women-empowerment/women-empowerment.component';
import { GuruPurnimaComponent } from './guru-purnima/guru-purnima.component';
import { AshadhiEkadashiComponent } from './ashadhi-ekadashi/ashadhi-ekadashi.component';
import { SanskrutikMohotsavComponent } from './sanskrutik-mohotsav/sanskrutik-mohotsav.component';
import { ShivajiMaharajJayantiComponent } from './shivaji-maharaj-jayanti/shivaji-maharaj-jayanti.component';
import { MarathiRajbhashaComponent } from './marathi-rajbhasha/marathi-rajbhasha.component';
import { MahaparinirvanDiwasComponent } from './mahaparinirvan-diwas/mahaparinirvan-diwas.component';
import { AntaragniComponent } from './antaragni/antaragni.component';
import { AnnualPrizeDistributionComponent } from './annual-prize-distribution/annual-prize-distribution.component';
import { PunyatithiOfAnnabhauSatheComponent } from './punyatithi-of-annabhau-sathe/punyatithi-of-annabhau-sathe.component';
import { InductionProgramComponent } from './induction-program/induction-program.component';
import { FoundersDayComponent } from './founders-day/founders-day.component';
import { CelebratingYogaDayComponent } from './celebrating-yoga-day/celebrating-yoga-day.component';
import { NssCampComponent } from './nss-camp/nss-camp.component';
import { GbMeetingComponent } from './gb-meeting/gb-meeting.component';
import { ScienceDayComponent } from './science-day/science-day.component';
import { CoderushComponent } from './coderush/coderush.component';
import { IndustryConnectComponent } from './industry-connect/industry-connect.component';
import { BusinessExpoComponent } from './business-expo/business-expo.component';
import { CynosureToastmastersComponent } from './cynosure-toastmasters/cynosure-toastmasters.component';
import { LightgalleryDirective } from './shared/lightgallery.directive';
import { GuestLecturerComponent } from './guest-lecturer/guest-lecturer.component';
import { DigitalMarketingWorkshopComponent } from './digital-marketing-workshop/digital-marketing-workshop.component';
import { AntiRaggingEventComponent } from './anti-ragging-event/anti-ragging-event.component';
import { UgProgramsComponent } from './ug-programs/ug-programs.component';
import { PgProgramsComponent } from './pg-programs/pg-programs.component';
import { EligibilityIntakeComponent } from './eligibility-intake/eligibility-intake.component';
import { FarewellPartyComponent } from './farewell-party/farewell-party.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    HomepageLayoutComponent,
    HeaderMenuComponent,
    AboutInstituteComponent,
    AboutRgiComponent,
    VisionMissionComponent,
    ChairmansMessageComponent,
    PrincipleMessageComponent,
    CoreValueComponent,
    CodeOfConductComponent,
    GoverningBodyComponent,
    AdmissionOverviewComponent,
    StudentScholarshipComponent,
    RgiScholarshipComponent,
    AdmissionHelplineComponent,
    FaqComponent,
    OnlineFeesPaymentComponent,
    UgBachelorOfBusinessAdministrationComputerApplicationComponent,
    UgBachelorOfBusinessAdministrationComponent,
    UgBachelorOfScienceComputerSciencenComponent,
    UgBachelorOfCommerceComponent,
    UgBachelorOfArtsComponent,
    UgBachelorOfScienceComponent,
    UgBachelorOfScienceHospitalityStudiesComponent,
    PgMastersOfCommerceComponent,
    PgMastersOfScienceComputerScienceComponent,
    AcademicCalenderComponent,
    CodeOfEthicsComponent,
    FeedbackProcessComponent,
    StudentProjectsComponent,
    QuestionPaperComponent,
    GrievanceRegistrationFormComponent,
    MinorityCellCommitteeComponent,
    AntiRaggingCommitteeComponent,
    CollegeDevelopmentCommitteeComponent,
    GrievanceRedressalCommitteeComponent,
    ExamGrievanceRedressalCommitteeComponent,
    NssCommitteeComponent,
    NaacCommitteeComponent,
    ObcCellCommitteeComponent,
    ScStCommitteeComponent,
    SportsCulturalCommitteeComponent,
    StudentCouncilCommitteeComponent,
    TrainingPlacementCommitteeComponent,
    WomensGrievanceRedressalCommitteeComponent,
    PlacementProcessComponent,
    PlacementTeamComponent,
    InternshipComponent,
    PastRecruitersComponent,
    TestimonialsComponent,
    RocsComponent,
    AboutIqacComponent,
    ObjectivesComponent,
    FunctionsComponent,
    IqacMembersComponent,
    MinutesOfMeetingComponent,
    AtrComponent,
    DocumentsComponent,
    PoCoComponent,
    CourseOutcomesComponent,
    NaacComponent,
    HostelComponent,
    StudentLifeComponent,
    AtheleticsSportsComponent,
    LibraryComponent,
    LabsComponent,
    ContactComponent,
    EventsComponent,
    NotfoundComponent,
    FeesStructureComponent,
    CityOfficeComponent,
    KimbaComponent,
    OnlineAntiRaggingAffidavitsComponent,
    AqarComponent,
    IctToolsComponent,
    ThankYouComponent,
    LoginComponent,
    BbaEntranceComponent,
    ExamGrievanceComponent,
    AdmissionCellCommitteeComponent,
    PlanningEvaluationCommitteeComponent,
    AcademicMonitoringDisciplineCommitteeComponent,
    ExaminationCommitteeComponent,
    ResearchDevelopmentCommitteeComponent,
    BuildingMaintenancePurchaseCommitteeComponent,
    BlogComponent,
    WhyAnBBAIsBestSuitedForYouComponent,
    WhyBscComputerScienceIsTheBestOrientedCourseComponent,
    Aqar21Component,
    HowToGetAdmissionToBcomComponent,
    WhyDidWeChooseBbaInComputerApplicationsComponent,
    TwentyOneComponent,
    BScInComputerScienceComponent,
    BachelorOfCommerceDegreeComponent,
    BachelorsDegreeInBusinessAdministrationComponent,
    BachelorOfCommerceDegreeAComprehensiveGuideComponent,
    BachelorOfBusinessAdministrationProgramComponent,
    BachelorOfBusinessAdministrationDegreeComponent,
    WhyChooseABachelorOfCommerceComponent,
    BachelorsDegreeAfterTwelveCommerceComponent,
    BbaComputerApplicationsComponent,
    BachelorOfBusinessDegreeComponent,
    BachelorDegreeComponent,
    TipsForCommerceStudentsPursuingABComDegreeComponent,
    WhyPursueBachelorOfComputerApplicationComponent,
    ScopeOfBbaComponent,
    BscComputerScienceCourseComponent,
    TipsForBscComputerScienceStudentComponent,
    AdvantagesOfBbaDegreeComponent,
    BbaInComputerApplicationComponent,
    BestBbaCoursesComponent,
    TopUniversitiesForBbaProgramsComponent,
    CareerOptionsAfterBachelorOfCommerceComponent,
    BbaInComputerApllicationsComponent,
    MComComponent,
    PgMscComponent,
    TwentytwoTwentythreeComponent,
    BscItComponent,
    BbaInternationalBusinessComponent,
    MscComputerScienceComponent,
    BscComputerAplicationComponent,
    RecrutersCourseComponent,
    DirectorMessageComponent,
    ExamCircularsComponent,
    LatestNewsComponent,
    TwentythreeTwentyfourComponent,
    DivyangCommitteeComponent,
    StudentsAchievementComponent,
    PopupModalComponent,
    WomenEmpowermentComponent,
    GuruPurnimaComponent,
    AshadhiEkadashiComponent,
    SanskrutikMohotsavComponent,
    ShivajiMaharajJayantiComponent,
    MarathiRajbhashaComponent,
    MahaparinirvanDiwasComponent,
    AntaragniComponent,
    AnnualPrizeDistributionComponent,
    PunyatithiOfAnnabhauSatheComponent,
    InductionProgramComponent,
    FoundersDayComponent,
    CelebratingYogaDayComponent,
    NssCampComponent,
    GbMeetingComponent,
    ScienceDayComponent,
    CoderushComponent,
    IndustryConnectComponent,
    BusinessExpoComponent,
    CynosureToastmastersComponent,
    LightgalleryDirective,
    GuestLecturerComponent,
    DigitalMarketingWorkshopComponent,
    AntiRaggingEventComponent,
    UgProgramsComponent,
    PgProgramsComponent,
    EligibilityIntakeComponent,
    FarewellPartyComponent,

  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    ReactiveFormsModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
